const mediaItems = [
  {
    id: 1,
    title: '《长安十二时辰》全集 — 古装悬疑巨制',
    desc: '雷佳音、易烊千玺领衔主演，唐朝上元节前夕，一场惊天阴谋悄然展开，死囚张小敬临危受命拯救长安。',
    tag: '热播推荐',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%2C%20cinematic%20moody%20atmosphere%2C%20historical%20drama%20aesthetic%2C%20warm%20golden%20and%20red%20tones%2C%20soft%20dramatic%20lighting%2C%20artistic%20film%20poster%20style%2C%20Tang%20dynasty%20setting%2C%20no%20text%20overlay&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《庆余年》第二季 — 权谋与江湖再续',
    desc: '张若昀携范闲归来，京都风云再起，庙堂权谋与江湖恩怨交织，全新剧情高潮迭起。',
    tag: '热播连载',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20palace%20courtyard%20with%20falling%20cherry%20blossoms%2C%20dramatic%20moody%20lighting%2C%20martial%20arts%20drama%20atmosphere%2C%20warm%20amber%20and%20deep%20red%20color%20scheme%2C%20film%20poster%20aesthetic%2C%20artistic%20illustration%2C%20no%20text&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《狂飙》全集 — 年度现象级扫黑大剧',
    desc: '张译、张颂文演技对决，二十年黑白较量，一部荡气回肠的正义史诗，全网口碑爆棚。',
    tag: '高分完结',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20cityscape%20at%20dusk%20with%20dramatic%20stormy%20clouds%2C%20crime%20drama%20atmosphere%2C%20high%20contrast%20cinematic%20lighting%2C%20warm%20amber%20streetlights%20against%20dark%20sky%2C%20film%20poster%20style%2C%20intense%20mood%2C%20no%20text&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            精彩推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热播剧场 · 精选好剧</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">每日精选高分电视剧，高清流畅在线观看，追剧不等待</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <article key={item.id} className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-primary-600"></i>
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}